import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
const routes = {
  settings: () => environment.webUrl + environment.apiUrl + `site-managers`,
  addSettings: () => environment.webUrl + environment.apiUrl + `site-managers/add`,
  pages: () => environment.webUrl + environment.apiUrl + `pages`
};
const headers: HttpHeaders = new HttpHeaders(
  {
  'Accept':'application/json',
  'appType': 'abdc12d02622aa11'
  });
@Injectable()
export class SettingsService {
  constructor(private http: HttpClient) { }
  getSettings() {
    return this.http.get(routes.settings(), {headers: headers}).pipe(
      map((body: any) => body),
      catchError((error: any) => error)
    );
  }
  editSettings(data, id) {
    return this.http.put(routes.settings() + '/' + id, data, {headers: headers}).pipe(
      map((body: any) => body),
      catchError((error: any) => error)
    );
  }
  addSettings(data) {
    return this.http.put(routes.addSettings(), data, {headers: headers}).pipe(
      map((body: any) => body),
      catchError((error: any) => error)
    );
  }
  getPages() {
    return this.http.get(routes.pages(), {headers: headers}).pipe(
      map((body: any) => body),
      catchError((error: any) => error)
    );
  }
  editPages(data, id) {
    return this.http.put(routes.pages()   + '/'+ id, data, {headers: headers}).pipe(
      map((body: any) => body),
      catchError((error: any) => error)
    );
  }
  addPages(data) {
    return this.http.put(routes.pages(), data, {headers: headers}).pipe(
      map((body: any) => body),
      catchError((error: any) => error)
    );
  }
}
